import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import { REGEX } from 'www/utils/regex'

/**
 * @description
 *
 * Функция возвращает объект для валидации поля "email"
 *
 * @returns {object} - объект функций с валидацией поля по различным параметрам. Каждая функция принимает обязательное значение поля - value
 */

const EMAIL_MAX_LENGTH = 65
const options = { ns: getUserLanguage() }

function getEmailValidation() {
  return {
    required: val => !!val || i18next.t('Укажите почту', options),
    onlyEn: val => !REGEX.ru.test(val) || i18next.t('Используйте только латиницу', options),
    regex: val => REGEX.email.test(val.trim()) || i18next.t('Некорректный email', options),
    maxLength: val => val.length <= EMAIL_MAX_LENGTH || `${i18next.t('Должно быть не больше', options)} ${EMAIL_MAX_LENGTH} ${i18next.t('символов', options)}`,
  }
}

export default getEmailValidation
